import { render, staticRenderFns } from "./ServicePlaceUsersGrid.vue?vue&type=template&id=58a39ac2&scoped=true&"
import script from "./ServicePlaceUsersGrid.vue?vue&type=script&lang=js&"
export * from "./ServicePlaceUsersGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a39ac2",
  null
  
)

export default component.exports